import { render, staticRenderFns } from "./ReChatSmall.vue?vue&type=template&id=1a81c085&scoped=true"
import script from "./ReChatSmall.vue?vue&type=script&lang=js"
export * from "./ReChatSmall.vue?vue&type=script&lang=js"
import style0 from "./ReChatSmall.vue?vue&type=style&index=0&id=1a81c085&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a81c085",
  null
  
)

export default component.exports